import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Card, Container } from 'reactstrap';
import TabControl from '../../../components/tabs/TabControl';
import { PathsLayouts } from '../../../config/routes';
import { TranslationsKeys } from '../../../locales/translations';
import SurveyDraftList from './parts/SurveyDraftList';
import SurveyList from './parts/SurveyList';

export default function Surveys() {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_SURVEY);
  const { state } = useParams<{ state: string }>();

  const tabs = useMemo(
    () => [
      {
        name: 'published',
        literalName: t(`tabs.surveysPublished`),
        content: <SurveyList />,
      },
      {
        name: 'draft',
        literalName: t(`tabs.surveysDraft`),
        content: <SurveyDraftList />,
      },
    ],
    [t],
  );

  return (
    <Container fluid>
      <Card className="">
        <TabControl tabs={tabs} path={PathsLayouts.surveys} key={state} />
      </Card>
    </Container>
  );
}
